import { open } from '@tauri-apps/plugin-dialog';
import { readTextFile } from '@tauri-apps/plugin-fs';
import type { EncryptedKeyFile } from '../../lib/crypto/accessKey';

export interface KeyStorageProvider {
  readKeyFile(): Promise<EncryptedKeyFile>;
  isKeyPresent(): Promise<boolean>;
}

let lastPath: string | null = null;

export const tauriKeyStorage: KeyStorageProvider = {
  async readKeyFile() {
    const selected = await open({
      multiple: false, directory: false,
      filters: [{ name: 'Clé CIME', extensions: ['json'] }],
      title: 'Sélectionnez cime-key.json sur votre clé USB',
    });
    if (typeof selected !== 'string') throw new Error('no-key-selected');
    lastPath = selected;
    return JSON.parse(await readTextFile(selected)) as EncryptedKeyFile;
  },
  // Portée session : tant que l'utilisateur n'a pas sélectionné de fichier dans
  // le process courant, renvoie false (re-sélection après redémarrage de l'app).
  async isKeyPresent() {
    if (!lastPath) return false;
    try { await readTextFile(lastPath); return true; } catch { return false; }
  },
};
